export default function StatusBadge({ status, size = 'md' }) {
  const baseClasses = 'inline-flex items-center rounded-full font-medium';

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-0.5 text-xs',
    lg: 'px-3 py-1 text-sm',
  };

  let colorClass = '';

  switch (status) {
    case 'ready':
    case 'connected':
    case 'active':
    case 'online':
    case 'success':
    case 'completed':
      colorClass = 'bg-success-900/30 text-success-400';
      break;
    case 'uploading':
    case 'processing':
    case 'connecting':
    case 'pending':
      colorClass = 'bg-blue-900/30 text-blue-400';
      break;
    case 'error':
    case 'disconnected':
    case 'failed':
    case 'rejected':
      colorClass = 'bg-error-900/30 text-error-400';
      break;
    case 'warning':
    case 'degraded':
    case 'paused':
      colorClass = 'bg-warning-900/30 text-warning-400';
      break;
    case 'offline':
    case 'inactive':
    case 'draft':
      colorClass = 'bg-dark-700 text-dark-400';
      break;
    default:
      colorClass = 'bg-dark-700 text-dark-400';
  }

  const displayText = status ? status.charAt(0).toUpperCase() + status.slice(1) : 'Unknown';

  return (
    <span className={`${baseClasses} ${sizeClasses[size]} ${colorClass}`}>
      {status === 'connected' || status === 'online' || status === 'active' || status === 'ready' || status === 'success' ? (
        <span className="mr-1 h-2 w-2 animate-pulse rounded-full bg-current"></span>
      ) : null}
      {displayText}
    </span>
  );
}
